import { schemaTypes } from "../../../constants/constants";
import {
  flipRange,
  canShowRangeSwitch,
  onFetchOdo,
  changeVehicle,
} from "./historyReport/historyReport";
import ReportAPIs from "../../../APIs/ReportAPIs";
import moment from "moment";

const getHourMin = (milisec) => {
  let hourmin = moment.duration(milisec);
  if (hourmin.hours() > 0 && hourmin.minutes() > 0) {
    return `${hourmin.hours()} hr ${hourmin.minutes()} min`;
  } else if (hourmin.hours() == 0 && hourmin.minutes() > 0) {
    return `${hourmin.minutes()} min`;
  } else {
    return `${hourmin.hours()} hr`;
  }
};

const formatter = (key, data) => {
  switch (key) {
    case "date":
      return moment(data).format("DD-MM-YYYY h:mm A");
    case "duration":
      return data ? getHourMin(data) : "NA";
    case "timestr":
      return (
        parseInt(moment.duration(data).days() * 24) +
        parseInt(moment.duration(data).hours()) +
        " hr " +
        " " +
        moment.duration(data).minutes() +
        " min "
      );
    case "event":
      return data === "c" ? "Charging" : "Trip";
    default:
      return data ? data : "NA";
  }
};
const downloadTripReport = (schema, nodata, store) => {
  let str = "";
  let filename = "EV_TRIP_REPORT.csv";
  let data = store.store.evReport.history;
  let heads = [
    {
      hdg: "Event",
      key: "state",
      type: "event",
    },
    {
      hdg: "Trip Start",
      key: "starttime",
      type: "date",
    },
    {
      hdg: "Trip End",
      key: "endtime",
      type: "date",
    },
    {
      hdg: "Start Voltage (V)",
      key: "startvolt",
      type: "none",
    },
    {
      hdg: "End Voltage (V)",
      key: "endvolt",
      type: "none",
    },
    {
      hdg: "Start SOC (%)",
      key: "startsoc",
      type: "none",
    },
    {
      hdg: "End SOC (%)",
      key: "endsoc",
      type: "none",
    },

    {
      hdg: "Total Distance (km)",
      key: "distance",
      type: "none",
    },
    {
      hdg: "Trip Duration",
      key: "dischargeduration",
      type: "duration",
    },
    {
      hdg: "SOC Charged (%)",
      key: "soccharged",
      type: "none",
    },
    {
      hdg: "Charge Duration",
      key: "chargeduration",
      type: "duration",
    },
    {
      hdg: "SOC Consumed (%)",
      key: "socconsumed",
      type: "none",
    },
  ];
  let headline = "Vehicle No,Model";
  for (var i = 0; i < heads.length; i++) {
    if (headline != "") headline += ",";
    headline += heads[i]["hdg"];
  }
  str += headline + "\r\n";
  let tripData = data;
  for (let idx in tripData) {
    let line = "";
    str += line + "\r\n";
    line = "";
    for (let jdx in tripData[idx].data.data) {
      for (let hdx in tripData[idx].data.data[jdx].values) {
        for (let kdx in heads) {
          if (kdx == 0) {
            line = tripData[idx].vehicleno + "," + tripData[idx].model;
          }
          if (line != "") line += ",";
          line += formatter(
            heads[kdx].type,
            tripData[idx].data.data[jdx].values[hdx][heads[kdx].key] || "NA"
          );
        }
        str += line + "\r\n";
        line = "";
      }
    }
    // str+=line+"\r\n";
  }

  var blob = new Blob([str], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

const getVehicleNo = (vehicleId, vehicleList) => {
  let vehicles = vehicleList;
  let result = vehicles.find((vehicle) => vehicle.id == vehicleId);
  return result.name;
};

const processReportData = (data, vehicles) => {
  let reportData = data.history;
  let finalData = [];
  for (let idx in reportData) {
    reportData[idx].vehicleno = getVehicleNo(
      reportData[idx].vehicleid,
      vehicles
    );
    finalData.push(reportData[idx]);
  }
  data.history = finalData;
  return data;
};

const getReport = (schema, data, store) => {
  this.finalData = null;
  let saveState = null;
  let tableStateData = null;
  store.dispatch({
    type: "SET_EV_LOADING",
    data: true,
  });
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(this.schema, true);
    const handleSuccess = (resp) => {
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(this.schema, false);
      store.dispatch({
        type: "SET_SELECTED_VEHICLE",
        data: data.vehicle,
      });
      store.dispatch({
        type: "SAVE_EV_REPORT",
        data: processReportData(resp, data.vehicle),
      });
      store.dispatch({
        type: "SET_EV_LOADING",
        data: false,
      });
    };
    let startTime = moment(data.starttime.unix() * 1000);
    let endTime = moment(data.endtime.unix() * 1000);
    if (endTime.diff(startTime, "days") >= 30) {
      store.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "You can't select a date range of more than 30 days",
          content: "You can't select date range of more than 30 days",
          createAt: Date.now(),
          autoClose: 7000,
          showError:true
        },
      });
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(this.schema, false);

      store.dispatch({
        type: "SET_EV_LOADING",
        data: false,
      });
      return;
    }

    let body = {
      vehicleid: data.vehicle.map((item) => {
        return item.data.vehicleid;
      }),
      starttime: data.starttime.unix() * 1000,
      endtime: data.endtime.unix() * 1000,
      numpoints: 1000,
      frequency: window.selectedFrequency ? window.selectedFrequency.id : "day",
      display: [
        "date",
        "totalkm",
        "totalenergy",
        "totalsoc",
        "totalchargingevents",
        "timespentincharging",
        "maxenergy",
        "maxsoc",
        "avgchargingtime",
        "avgenergyintake",
        "avgsocintake",
        "avgkm",
      ],
    };

    ReportAPIs.getEVTripReport(body).then(handleSuccess, (r) => {
      handleSuccess({});
    });
  } else {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select atleast 1 vehicle",
        content: "Please select atleast 1 vehicle",
        createAt: Date.now(),
        autoClose: 7000,
        showError:true
      },
    });
    store.dispatch({
      type: "SET_EV_LOADING",
      data: false,
    });
  }
};

const schema = {
  key: "ev_report",
  name: "EV Analytics",
  toolbar: [
    {
      key: "vehicle",
      singleSelect: false,
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      maxCount: 1000,
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Report",
      onClick: getReport,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: downloadTripReport,
    },
  ],
  content: [
    {
      key: "ev_report",
      name: "EV Analytics",
      type: schemaTypes.EV_REPORT,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
    },
  ],
};

export default schema;
